const activeLesson = (state = {}, action) => {
    if (action.type === 'SET_ACTIVE_LESSON')
    {
        return action.payload;
    } 
    else {
        return state; 
    }
}
export default activeLesson;